import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { NoFilteredResults } from 'Images';

export const NoResults = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Documents);
  return (
    <Stack alignItems='center' gap='16px'>
      <Avatar
        alt=''
        src={NoFilteredResults}
        sx={{ width: '180px', height: '175px' }}
      />
      <Stack alignItems='center'>
        <Typography variant='h6'>{dictionary.noDocFoundFilter}</Typography>
        <Typography variant='body3'>{dictionary.adjustFilter}</Typography>
      </Stack>
    </Stack>
  );
};
